"use client";

import confetti from "canvas-confetti";
import { useEffect } from "react";
import Link from "next/link";

export default function ThankYou() {
  useEffect(() => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });
  }, []);

  return (
    <main className="flex flex-col items-center justify-center px-6 py-32 min-h-screen bg-[#f9fafb]">
      <div className="max-w-xl w-full text-center">
        <h1 className="text-5xl font-bold mb-6 text-gray-900">
          🎉 You&apos;re In!
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          Thank you for subscribing to WebFindsFriday.
          <br />
          Expect curated gems delivered every Friday.
        </p>
        <p className="text-md text-gray-500 mb-8">
          Feel free to bookmark this page or share with friends.
        </p>
        <Link
          href="/"
          className="bg-gray-900 text-white px-6 py-3 rounded-lg hover:bg-gray-800 transition-all font-semibold"
        >
          ← Back to WebFindsFriday
        </Link>
      </div>
    </main>
  );
}
